<div class="container-fluid">
  <div class="modal-header preview-header" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
    <div class="preview-header__title">
      <h5>{{displayTemplateName | uppercase}}</h5>
      <span class="preview-header__owner">{{envelopeOwnerName | uppercase}}</span>
    </div>
    <div class="preview-header__actions">
        <button mat-flat-button class="mat-success" (click) = "onSend()" [disabled] = "!isNotDraft">
            <mat-icon>send</mat-icon>
            Send
        </button>
        <button mat-stroked-button mat-dialog-close aria-label="Close dialog">
            Close
        </button>
    </div>
  </div>
  <!-- Draft only: who it will go to (sent envelopes show this in the recipient status panel) -->
  <div class="preview-send-to" *ngIf="isNotDraft">
    <div>
      <span class="preview-send-to__label">Send to</span>
      <ng-container *ngIf="templateName?.toLowerCase() === _templateNames?.AOB; else standardHeader;">
        <span class="preview-send-to__recipient">
          <span class="preview-send-to__role">{{applicantType | uppercase}}</span>
          <span><mat-icon>mail_outline</mat-icon>{{sendTo}}</span>
          <span *ngIf="primaryPhoneNumber"><mat-icon>phone</mat-icon>{{primaryPhoneNumber}}</span>
        </span>
        <span class="preview-send-to__recipient">
          <span class="preview-send-to__role">CO-APPLICANT</span>
          <span><mat-icon>mail_outline</mat-icon>{{sendToCoApp}}</span>
          <span *ngIf="coAppPhoneNumber"><mat-icon>phone</mat-icon>{{coAppPhoneNumber}}</span>
        </span>
      </ng-container>
      <ng-template #standardHeader>
        <span class="preview-send-to__recipient">
          <span class="preview-send-to__role">{{applicantType | uppercase}}</span>
          <span><mat-icon>mail_outline</mat-icon>{{sendTo}}</span>
          <span *ngIf="(applicantType?.toLowerCase() === 'primary' ? primaryPhoneNumber : coAppPhoneNumber) as phone"><mat-icon>phone</mat-icon>{{phone}}</span>
        </span>
      </ng-template>
    </div>
    <!-- <div  style="display: flex; flex-direction: row; gap: 2px; justify-content: end; margin-right: 15px;">
      <mat-checkbox color="primary" [(ngModel)]="defaultDeliveryEmail">Email</mat-checkbox>
      <div *ngFor="let option of _deliveryOptions">
          <mat-checkbox color="primary"
            [checked]="selectedDeliveryOption === option.value"
            (change)="additionalDeliverOption(option.value)">
          {{ option.display }}
        </mat-checkbox>
      </div>
    </div> -->
  </div>
  <div class="status-legend" *ngIf="statusTone !== 'draft'">
    <span class="legend-item" [class.legend-item--inactive]="statusTone !== 'draft'"><span class="legend-dot legend-dot--draft"></span>Draft</span>
    <span class="legend-item" [class.legend-item--inactive]="statusTone !== 'sent'"><span class="legend-dot legend-dot--sent"></span>Sent</span>
    <span class="legend-item" [class.legend-item--inactive]="statusTone !== 'void'"><span class="legend-dot legend-dot--void"></span>Void</span>
    <span class="legend-item" [class.legend-item--inactive]="statusTone !== 'completed'"><span class="legend-dot legend-dot--completed"></span>Completed</span>
  </div>
  <div class="modal-body" [class.modal-body--with-status]="showRecipientStatus">
    <div class="preview-pdf">
    <ngx-extended-pdf-viewer
        [src]="pdfSource" 
        useBrowserLocale="true"
        [zoom]="'80%'"
        [showPrintButton]="false"
        [showDownloadButton]="false"
        [showOpenFileButton]="false"
        [showRotateButton]="false"
        [showSecondaryToolbarButton]="false"
        [showDrawEditor]="false"
        [showTextEditor]="false"  
        [showStampEditor]="false"
        [textLayer]="true">
    </ngx-extended-pdf-viewer>
    </div>

    <!-- Once sent, show where each recipient is (same panel as Agreements) -->
    <div class="preview-status" *ngIf="showRecipientStatus" [ngClass]="'preview-status--' + statusTone">
      <div class="preview-status__header">
        <span>Recipients</span>
        <mat-icon class="preview-status__refresh" (click)="refreshRecipientStatus()" matTooltip="Refresh status">refresh</mat-icon>
      </div>
      <div class="preview-status__body">
        <app-agreements-recipient-status 
        [envelopeId]="envelopeId"
        [appData]="appData"
        [(currentUser)]="currentUser" >
      </app-agreements-recipient-status>
      </div>
    </div>
  </div>
</div>